import React from 'react'

import { LogoTooltip, LogosContainer } from './Styles'

interface Props {
  carrier: string
  carrierName: string | null
}

const FlightLogo = ({ carrier, carrierName }: Props) => {
  const [show, setShow] = React.useState(false)
  const handleMouseEnter = React.useCallback(() => setShow(true), [])
  const handleMouseLeave = React.useCallback(() => setShow(false), [])

  return (
    <LogosContainer key={carrier}>
      <img
        src={`${process.env.PUBLIC_URL}/airline_logos/${carrier.toUpperCase()}_small.png`}
        alt="airlogo"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
      {carrierName ? <LogoTooltip show={show}>{carrierName}</LogoTooltip> : null}
    </LogosContainer>
  )
}

export default React.memo(FlightLogo)
